export const timeConfiguration = {
  hours: 12,
  minutes: 0,
  seconds: 0,
  milliseconds: 0
} as const
